'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const ShortTaxMessage = renderWithRef('ShortTaxMessage', null, (s, o)=>{
    let { children: t } = s;
    return jsx(RenderComp, {
        root: "span",
        forwardedRef: o,
        classNames: new Set([
            'swan-short-tax-message'
        ]),
        props: s,
        children: t
    });
});

export { ShortTaxMessage };
